var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":_vm.$t('checklist.sidebar.shortTitle'),"logo":_vm.$store.getters.systemLogoSidebar,"titleImg":_vm.$store.getters.systemTitleImage,"title":_vm.$store.getters.systemTile}},[_c('template',{slot:"links"},[(_vm.isUserFormCreator)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.dashboard'),
          icon: 'tim-icons icon-chart-pie-36',
          path: '/checklist/dashboard/default',
        }}}):_vm._e(),_c('sidebar-item',{ref:"sidebarItemForms",attrs:{"link":{
          name: _vm.$t('checklist.sidebar.Forms'),
          icon: 'tim-icons icon-notes',
        }}},[(_vm.isUserFormCreator)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('checklist.sidebar.Create'),
            path: '/checklist/Layout/form/Create/',
            icon: 'tim-icons icon-upload',
          }}}):_vm._e(),(_vm.isUserFormCreator || _vm.isUserFormFiller)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('checklist.sidebar.Own'),
            path: '/checklist/Layout/form/Own/',
            icon: 'tim-icons icon-upload',
          }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('checklist.sidebar.Filled'),
            path: '/checklist/Layout/form/Filled/',
            icon: 'tim-icons icon-upload',
          }}}),(_vm.isUserFormFiller)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('checklist.sidebar.Draft'),
            path: '/checklist/Layout/form/Draft/',
            icon: 'tim-icons icon-upload',
          }}}):_vm._e()],1),(_vm.isUserPendenciesViewer)?_c('sidebar-item',{ref:"sidebarItemPendencies",attrs:{"link":{
          name: _vm.$t('checklist.sidebar.Pendencies'),
          icon: 'tim-icons icon-alert-circle-exc',
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('checklist.sidebar.pendenciesOpened'),
            path: '/checklist/pendencies/opened/',
            icon: 'tim-icons icon-alert-circle-exc',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('checklist.sidebar.pendenciesApproved'),
            path: '/checklist/pendencies/approved/',
            icon: 'tim-icons icon-alert-circle-exc',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('checklist.sidebar.pendenciesDisapproved'),
            path: '/checklist/pendencies/disapproved/',
            icon: 'tim-icons icon-alert-circle-exc',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('checklist.sidebar.pendenciesExpired'),
            path: '/checklist/pendencies/expired/',
            icon: 'tim-icons icon-alert-circle-exc',
          }}})],1):_vm._e(),(_vm.$store.getters.isAdminRms == true)?_c('sidebar-item',{attrs:{"link":{
          name: 'Clonar formulário',
          path: '/checklist/cloningForm',
          icon: 'tim-icons icon-single-copy-04',
        }}}):_vm._e(),(_vm.$store.getters.isAdminRms == true)?_c('sidebar-item',{attrs:{"link":{
          name: 'Scripts',
          path: '/checklist/predefinedScript/list',
          icon: 'tim-icons icon-caps-small',
        }}}):_vm._e(),(_vm.isAccessVehicles)?_c('sidebar-item',{ref:"sidebarItemVehicle",attrs:{"link":{
          name: 'Equipamentos',
          icon: 'tim-icons icon-delivery-fast',
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Equipamentos',
            path: '/checklist/vehicleRegistration/list',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Marca do Equipamento',
            path: '/checklist/brandVehicle/list',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Modelo do Equipamento',
            path: '/checklist/vehicleModel/list',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Tipo do Equipamento',
            path: '/checklist/vehicleType/list',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Ativar/Desativar',
            path: '/checklist/vehicleAvailableReason/list',
          }}})],1):_vm._e(),(_vm.$store.getters.accessRevisionMenu)?_c('sidebar-item',{ref:"sidebarRevisions",attrs:{"link":{
          name: 'Manutenções',
          icon: 'tim-icons icon-settings',
        }}},[(_vm.$store.getters.accessRevisionDashboard)?_c('sidebar-item',{attrs:{"link":{
            name: 'Painel Manutenções',
            path: '/checklist/reviewDashboard',
          }}}):_vm._e(),(_vm.$store.getters.accessRevision)?_c('sidebar-item',{attrs:{"link":{
            name: 'Entradas de Manutenções',
            path: '/checklist/vehicleRevisionEntry/list',
          }}}):_vm._e(),(_vm.$store.getters.accessRevision)?_c('sidebar-item',{attrs:{"link":{
            name: 'Saída de Manutenções',
            path: '/checklist/vehicleRevisionExit/list',
          }}}):_vm._e(),(_vm.$store.getters.accessRevisionIndex)?_c('sidebar-item',{attrs:{"link":{
            name: 'Valores de Índice',
            path: '/checklist/vehicleRevision/indiceValues',
          }}}):_vm._e()],1):_vm._e(),(_vm.$store.getters.accessFuelSupplyMenu)?_c('sidebar-item',{ref:"sidebarFuelSupply",attrs:{"link":{
          name: _vm.$t('fuelSupply.sidebarMain'),
          materialIcon: 'local_gas_station',
        }}},[(_vm.$store.getters.accessFuelSupplyDashboard)?_c('sidebar-item',{attrs:{"link":{
            name: 'Painel de Abastecimentos',
            path: '/checklist/fuelSupplyDashboard',
            icon: 'tim-icons icon-alert-circle-exc',
          }}}):_vm._e(),(_vm.$store.getters.accessFuelSupplyDashboardHorimeter)?_c('sidebar-item',{attrs:{"link":{
            name: 'Painel de Abastecimentos Horimetro',
            path: '/checklist/fuelSupplyDashboardHorimetro',
            icon: 'tim-icons icon-alert-circle-exc',
          }}}):_vm._e(),(_vm.$store.getters.accessFuelSupply)?_c('sidebar-item',{attrs:{"link":{
            name: 'Registros de Abastecimentos',
            path: '/checklist/fuelSupply/list',
            icon: 'tim-icons icon-alert-circle-exc',
          }}}):_vm._e(),(_vm.$store.getters.accessFuelConsumptionTarget)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('fuelConsumptionTarget.sidebar'),
            path: '/checklist/fuelConsumptionTarget/list',
            icon: 'tim-icons icon-alert-circle-exc',
          }}}):_vm._e(),(_vm.$store.getters.accessFuelStock)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('fuelStock.sidebar'),
            path: '/checklist/fuelStock/list',
            icon: 'tim-icons icon-alert-circle-exc',
          }}}):_vm._e(),(_vm.$store.getters.accessGasStation)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('gasStation.sidebar'),
            path: '/checklist/gasStation/list',
            icon: 'tim-icons icon-alert-circle-exc',
          }}}):_vm._e(),(_vm.$store.getters.isAdminRms == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Importação de Abastecimentos',
            path: '/checklist/fuelSupply/import',
            icon: 'tim-icons icon-alert-circle-exc',
          }}}):_vm._e()],1):_vm._e(),(_vm.isUserViewer)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.usuarios'),
          path: '/checklist/user/list',
          icon: 'tim-icons icon-single-02',
        }}}):_vm._e(),(_vm.isProfileViewer)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('system.profile.sidebar'),
          path: '/checklist/profile/all',
          icon: 'tim-icons icon-single-02',
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.sector'),
          path: '/checklist/sector/all',
          icon: 'tim-icons icon-vector',
        }}}),(_vm.isMasterAdmin)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('system.module.sidebar'),
          path: '/checklist/module/all',
          icon: 'tim-icons icon-components',
        }}}):_vm._e(),(
          _vm.$store.getters.isAdminRms == true ||
          _vm.$store.getters.companyId == 1 ||
          _vm.$store.getters.companyId == 177
        )?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.empresas'),
          path: '/checklist/company/list',
          icon: 'tim-icons icon-bank',
        }}}):_vm._e(),(
          _vm.$store.getters.companyId == 1 || _vm.$store.getters.companyId == 177
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Financeiro',
          materialIcon: 'attach_money',
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.plans'),
            path: '/checklist/plans/list',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.voucher'),
            path: '/checklist/voucher/list',
          }}})],1):_vm._e(),(_vm.$store.getters.isAdminRms == true || _vm.isAccessVehicles == true)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.costCenterTitle'),
          path: '/checklist/costCenter/list',
          icon: 'tim-icons icon-money-coins',
        }}}):_vm._e(),(_vm.$store.getters.isAdminRms == true)?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('system.systemIntegration.sidebar'),
          path: '/checklist/systemIntegration/all',
          icon: 'tim-icons icon-single-02',
        }}}):_vm._e(),(_vm.isUserFormFiller)?_c('sidebar-item',{ref:"sidebarItemSchedules",attrs:{"link":{
          name: _vm.$t('scheduler.schedules'),
          icon: 'tim-icons icon-notes',
        }}},[(_vm.isUserFormCreator)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('checklist.sidebar.Create'),
            path: '/checklist/scheduler/forms',
            icon: 'tim-icons icon-upload',
          }}}):_vm._e(),(_vm.isUserFormCreator)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('scheduler.schedules'),
            path: '/checklist/schedules/',
            icon: 'tim-icons icon-single-02',
          }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('geral.pending'),
            path: '/checklist/pending/',
            icon: 'tim-icons icon-upload',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('geral.typing'),
            path: '/checklist/typing/',
            icon: 'tim-icons icon-upload',
          }}})],1):_vm._e()],1)],2),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar',{attrs:{"module":"checklist"}}),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }